import { createGlobalStyle } from '@xstyled/styled-components';
import blueJones from '~/assets/fonts/blue-jones.woff2';
import raleway from '~/assets/fonts/Raleway-Regular.woff2';
import recoleta from '~/assets/fonts/Recoleta-Regular.woff2';
import ralewayBold from '~/assets/fonts/Raleway-Bold.woff2';
import recoletaBold from '~/assets/fonts/Recoleta-SemiBold.woff2';

export const MainStyle = createGlobalStyle`
  @font-face {
    font-family: bluejones;
    src: url(${blueJones});
  }

  @font-face {
    font-family: raleway;
    src: url(${raleway});
  }

  @font-face {
    font-family: recoleta;
    src: url(${recoleta});
  }

  @font-face {
    font-family: ralewayBold;
    src: url(${ralewayBold});
  }

  @font-face {
    font-family: recoletaBold;
    src: url(${recoletaBold});
  }

  :root {
    --color-black: #000000;
    --color-white: #ffffff;

    --color-grey-dk: #6f6f6f;
    --color-grey-md: #e0e0e0;
    --color-grey-lt: #f5f5f5;

    --color-accent-dk: #9845FB;
    --color-accent-md: #9D76FB;
    --color-accent-lt: #F1EEFE;

    --color-yellow-dk: #FDD15F;
    --color-yellow-md: #F8EAB7;
    --color-yellow-lt: #FCF8E9;

    --color-green-dk: #00A876;
    --color-green-md: #92E8BF;
    --color-green-lt: #E8FAED;

    --color-red-dk: #F7326D;
    --color-red-md: #FABCCB;
    --color-red-lt: #FDF2F4;
    
    --color-blue-md: #0975FD;

    --color-pink-lt: #F3ECFF;
    --color-pink-lt2: #F3ECFF;

    --title-font: recoleta;
    --body-font: raleway;
    --llama-font: bluejones;
  }

  html, body, .root, #root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    color: var(--color-accent);
  }

  p {
    margin: 0;
  }

  button {
    cursor: pointer;
  }

  textarea {
    border: none;
    background: var(--color-grey-lt);
    border-radius: md;
  }

  video::-webkit-media-controls {
    display: none;
  }
  
  .dontForget {
      background: var(--color-accent-dk);
      color: var(--color-white);
      padding: 5px;
      padding-left: 10px;
      padding-right: 10px;
      opacity: 0.7;
      border-radius: 10px;
  }

  .subtitleStyleForDarkTheme {
    padding: 5px;
    width: fit-content;
    background-color: #FAFEFB;
    border-radius: 8px;
    
    svg {
      position: relative;
    }
  }

  .text-align-left {
    text-align: left !important;
  }

  .text-align-center {
    text-align: center !important;
  }

  .text-align-right {
    text-align: right !important;
  }

  .text-align-justify {
    text-align: justify !important;
  }
`;
